export default {
  vector_1: require("assets/img/bg/v_1.png"),
  vector_2: require("assets/img/bg/v_2.png"),
  simple_bg: require("assets/img/bg/simple_bg.png"),
  left_img: require("assets/img/bg/left_img.png"),
  logo_name: require("assets/img/bg/logo_name.png"),
  email_logo: require("assets/img/email_logo.png"),
  password_logo: require("assets/img/password_logo.png"),
  linkedIn_social: require("assets/img/linkedIn_social.svg"),
  default_picture: require("assets/img/default_picture.png"),
  forward_vector: require("assets/img/forward_vector.png"),
  add_resume: require("assets/img/add_resume.png"),
  Listofallusers: require("assets/img/Listofallusers.png"),
  ApproveAccounts: require("assets/img/ApproveAccounts.png"),
  Business: require("assets/img/Business.png"),
  Referrals: require("assets/img/Referrals.png"),
  RequestAdditionalExpert: require("assets/img/RequestAdditionalExpert.png"),
  SignedContracts: require("assets/img/SignedContracts.png"),
  HistoricalView: require("assets/img/HistoricalView.png"),
  Benefits: require("assets/img/Benefits.png"),
  ManagementHistory: require("assets/img/ManagementHistory.png"),
  Experts: require("assets/img/Experts.png"),
  LogLight: require("assets/img/LogLight.png"),
  threedots: require("assets/img/threedots.png"),
  star: require("assets/img/star.png"),
  eye: require("assets/img/eye.png"),
  darkSearch: require("assets/img/darkSearch.png"),
  EngagementInfo: require("assets/img/EngagementInfo.png"),
  EditProfileInfo: require("assets/img/EditProfileInfo.png"),
  Rectangle: require("assets/img/Rectangle.png"),
  filtericon: require("assets/img/filtericon.png"),
  down: require("assets/img/down.png"),
  LogHistory: require("assets/img/LogHistory.png"),
  Engagements: require("assets/img/Engagements.png"),
  BillingInformations: require("assets/img/BillingInformations.png"),
  EducationalCenter: require("assets/img/EducationalCenter.png"),
  ResourceArea: require("assets/img/ResourceArea.png"),
  cros: require("assets/img/cros.png"),
  eye: require("assets/img/eye.png"),
  CSearch: require("assets/img/CSearch.png"),
  accept: require("assets/img/accept.png"),
  end: require("assets/img/end.png"),
  feedbackTick: require("assets/img/feedbackTick.png"),
  info: require("assets/img/info.png"),
  logout: require("assets/img/logout.png"),
  Vector_1: require("assets/img/icons/Vector1.png"),
  Vector_2: require("assets/img/icons/Vector2.png"),
  Vector_3: require("assets/img/icons/Vector3.png"),
  Vector_4: require("assets/img/icons/Vector4.png"),
  Vector_5: require("assets/img/icons/Vector5.png"),
  Vector_6: require("assets/img/icons/Vector6.png"),
  Vector_7: require("assets/img/icons/Vector7.png"),
  edit: require("assets/img/edit.png"),
  biling: require("assets/img/biling.png"),
  payment: require("assets/img/payment.png"),
  textandG: require("assets//img/bg/textandG.png"),

  profile_page_1: require("assets/img/icons/pagination1.png"),
  profile_page_2: require("assets/img/icons/pagination2.png"),
  Read_Icon: require("assets/img/icons/Read_Icon.png"),
  Unread_Icon: require("assets/img/icons/Unread_Icon.png"),
  menu_icon: require("assets/img/icons/menu_icon.png"),
  plus_icon: require("assets/img/icons/plus_icon.png"),
  minus_icon: require("assets/img/icons/minus_icon.png"),
  back_button: require("assets/img/icons/back_button.png"),
  feedBack: require("assets/img/feedBack.png"),
  dummy_avatar: require("assets/img/dummy_avatar.jpg"),
  plus: require("assets/img/plus.png"),
  cardPic: require("assets/img/cardPic.png"),

  mines: require("assets/img/mines.png"),
  dotss:require("assets/img/dotss.png"),
  del:require("assets/img/del.png"),
  addC:require("assets/img/icons/addC.png"),
  not:require("assets/img/icons/not.png"),


  


  
}
